export enum AIButtonVariant {
  SUBDUED = 'subdued',
  DEFAULT = 'default',
  PREMIUM = 'premium',
  PREMIUM_SUBDUED = 'premium_subdued',
  PREMIUM_2 = 'premium_2',
}
